import { useBoundStore } from '@Store/useBoundStore';
import { REASON_FOR_OPEN } from '../consts';
import { trackEvent } from '@Services/analytics/tracking.service';

export const useAccountOpeningReasonAnalytics = () => {
  const customerId = useBoundStore((state) => state.customer.customerId);
  const reportActOnAccountOpenReason = (reason: REASON_FOR_OPEN) => {
    trackEvent('action on reason opening account OB', {
      select_creation_reason: reason,
      distinct_id: customerId,
    });
  };

  return { reportActOnAccountOpenReason };
};
